import React from 'react';
import { Container, Typography } from '@material-ui/core';
import {
  Line,
  LineChart as LineChartContainer,
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts';
import { chartDataObject, month_results } from '../../@types/chartData';

import './style.css';
import Colors from '../Colors';

interface ChartData {
  legendaY?: string;
  year: string;
  nDead: string;
  uv?: number;
  pv?: number;
  wv?: number;
}

interface legendsProps {
  projection?: boolean;
  legendY?: string;
  legendOne?: string;
  legendTwo?: string;
  legendThree?: string;
  data: ChartData[] | chartDataObject[] | month_results[];
  OMS?: boolean;
  lineTwo: boolean;
}

const LineChart: React.FC<legendsProps> = ({
  projection,
  legendY,
  legendOne,
  legendTwo,
  legendThree,
  data,
  OMS,
  lineTwo,
}) => {
  return (
    <Container className="Root">
      {data.length === 0 ? (
        <Typography variant="h4" className="Text">Ainda não há dados</Typography>
      ) : (
        <>
          {legendY && (
            <Typography variant="subtitle1" style={{ marginBottom: '2%' }}>
              {legendY}
            </Typography>
          )}

          <ResponsiveContainer width="100%" height={300}>
            <LineChartContainer
              data={data}
              margin={{ top: 10, right: 10, bottom: 15, left: 0 }}
            >
              <CartesianGrid
                vertical
                stroke="rgba(0, 0, 0, 0.15)"
                strokeDasharray="3 2"
              />

              <Line
                type="linear"
                dataKey="count_line1"
                name={legendOne}
                stroke={Colors.main}
                strokeWidth={3}
                legendType="rect"
                label={{
                  fill: Colors.main,
                  dy: -15,
                  fontWeight: '800',
                  fontSize: '0.7em',
                  visibility: 'visible',
                }}
                dot={{ stroke: Colors.main, strokeWidth: 2, r: 5 }}
                activeDot={{ stroke: Colors.main, r: 5 }}
                isAnimationActive={false}
              />
              {!lineTwo ? (
                false
              ) : projection ? (
                <Line
                  type="linear"
                  dataKey="count_line2"
                  name={legendTwo}
                  stroke="#00A7C5"
                  strokeWidth={3}
                  legendType="rect"
                  label={{
                    fill: Colors.main,
                    dy: -15,
                    fontWeight: '800',
                    fontSize: '0.7em',
                    visibility: 'visible',
                  }}
                  dot={{ stroke: Colors.main, strokeWidth: 2, r: 5 }}
                  activeDot={{ stroke: Colors.main, r: 5 }}
                  isAnimationActive={false}
                />
              ) : (
                <Line
                  type="linear"
                  dataKey="count_line2"
                  name={legendTwo}
                  stroke="#00A7C5"
                  strokeWidth={3}
                  legendType="rect"
                  dot={{ stroke: Colors.main, strokeWidth: 2, r: 5 }}
                  activeDot={{ stroke: Colors.main, r: 5 }}
                  label={{
                    fill: Colors.main,
                    fontWeight: '800',
                    fontSize: '0.7em',
                    zIndex: 100,
                    dy: -10,
                    visibility: 'visible',
                  }}
                  isAnimationActive={false}
                />
              )}

              <XAxis
                dataKey="title"
                stroke="#6f6f6f"
                type="category"
                tickLine={false}
                tickSize={15}
                padding={{ left: 10, right: 10 }}
                allowDataOverflow
              />
              <YAxis
                stroke="#6f6f6f"
                type="number"
                tickLine={false}
                tickSize={10}
                tickCount={10}
                tickFormatter={(value) => Math.round(Number(value))}
                domain={OMS ? [0, 18] : [0, (dataMax) => dataMax + dataMax / 10]}
              />
              {data ? (
                <Tooltip
                  wrapperStyle={{
                    fontWeight: '400',
                    backgroundColor: '#fff',
                    border: '1px solid #ddd',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  labelStyle={{
                    fontWeight: 'bolder',
                  }}
                />
              ) : null}
              {legendOne ? (
                <Legend
                  verticalAlign="bottom"
                  iconType="rect"
                  iconSize={15}
                  wrapperStyle={{ bottom: '0' }}
                />
              ) : null}
            </LineChartContainer>
          </ResponsiveContainer>
        </>
      )}
    </Container>
  );
};

export default LineChart;
